import React, { useEffect, useState } from "react";
import { useForm, ValidationError } from "@formspree/react";
import "./Footer.css";

const Footer = () => {
  const [state, handleSubmit] = useForm("mldrablb");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    const lastSubmissionTime = localStorage.getItem("lastSubmissionTime");
    const now = new Date().getTime();

    if (lastSubmissionTime) {
      const elapsed = now - parseInt(lastSubmissionTime, 10);
      const hoursPassed = elapsed / (1000 * 60 * 60);

      if (hoursPassed < 24) {
        setIsButtonDisabled(true);
        document.getElementById("footer-button").style.cursor = "not-allowed";
      }
    }
  }, []);

  const openForm = () => {
    document.getElementById("formContainer").style.display = "flex";
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    try {
      await handleSubmit(event);

      if (state.succeeded) {
        localStorage.setItem("lastSubmissionTime", new Date().getTime());
        setIsButtonDisabled(true);
        document.getElementById("footer-button").style.cursor = "not-allowed";
        document.getElementById("formContainer").style.display = "none";
      }
    } catch (error) {
      // Handle error
    }
  };

  return (
    <>
      <div className="form-container" id="formContainer">
        {state.succeeded ? (
          <div className="thank-you-message">
            <p>Thanks for your feedback!</p>
            <button type="button" onClick={() => document.getElementById("formContainer").style.display = "none"} className="close-btn">
              Close
            </button>
          </div>
        ) : (
          <form className="feedback-form" onSubmit={handleFormSubmit}>
            <button type="button" className="close-btn" onClick={() => document.getElementById("formContainer").style.display = "none"}>
              ×
            </button>
            <label htmlFor="email">Email Address:</label>
            <input id="email" type="email" name="email" required autoComplete="off" />
            <ValidationError
              prefix="Email"
              field="email"
              errors={state.errors}
            />
            <label htmlFor="message">Feedback / Suggestion:</label>
            <textarea
              id="message"
              name="message"
              rows="5"
              placeholder="Enter your feedback here..."
              required
            ></textarea>
            <ValidationError
              prefix="Message"
              field="message"
              errors={state.errors}
            />
            <button
              type="submit"
              className="my-button btn-green"
              disabled={state.submitting}
            >
              Send
            </button>
          </form>
        )}
      </div>

      <footer className="footer">
        <button
          id="footer-button"
          className="footer-button"
          onClick={openForm}
          disabled={isButtonDisabled}
        >
          Feedback / Suggestions
        </button>
        <p className="footer-text">
          &copy; {new Date().getFullYear()} Texify Elite. All rights reserved.
        </p>
      </footer>
    </>
  );
};

export default Footer;
